import type { FaireProductEntity } from "../../entity_types/product";

export const p_50kyjdummp: FaireProductEntity = {
  token: "p_50kyjdummp",
  type: "product",
  name: "Woods Mini Candle",
  brandToken: "b_7ltlwh1w",
  brandName: "True Hue",
  imageUrl:
    "https://cdn.faire.com/fastly/cc7bf3d09dc48db6dc044ba3c34d6341f25db69a78bb0a930d120565f72814d9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d661d6ffe516eed29cfa1a650961ac85d034eb5b85b82377382437a9e882adf.jpeg",
    "https://cdn.faire.com/fastly/035e92a56067d768793abcc7a2d0c9949010b31e754a5de0560676088be88f5f.jpeg",
    "https://cdn.faire.com/fastly/52ef0c47e4dd10ddc6cef9973e30a5f6bb564293ac7eee325d6ec632657c31f2.jpeg",
    "https://cdn.faire.com/fastly/ba5d0a609b57a827d258849696995108b09f3b97c43a950eda05009dcb92139f.png",
  ],
  priceDollars: 7,
  description:
    'Notes: Birchwood + Oud\n\nBeams of light pierce through huddled deciduous white oaks, birch, and cotton wood. Stark silhouettes race across the forest floor while leaves on branches hold on tightly through their dancing in the smoky wind.\n\nThis 2 oz candle is comprised of a premium soy wax blend and fine fragrance oils (all are Prop 65 and I.F.R.A. approved). Each candle comes complete with a braided cotton wick which burns cleanly for 15-20 hours.\n\n• Excellent stocking stuffer!\n\n𝐌𝐞𝐚𝐬𝐮𝐫𝐞𝐦𝐞𝐧𝐭𝐬:\n\n• Box Size: 2" L X 2" W X 2.7" H\n• Candle Size: 2" D X 2.5" H',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:00.266Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
